export enum MEMBERSHIP_TYPE {
   GREEN = 'GREEN',
   WHITE = 'WHITE',
   SILVER = 'SILVER',
   GOLD = 'GOLD',
   DIAMOND = 'DIAMOND',
}

export enum MEMBERSHIP_PRICE_TYPE {
   MONTHLY = 'monthly',
   THREE_MONTH = '3-month',
   SIX_MONTH = '6-month',
   ANNUALLY = 'annually',
   ONE_ROUND = 'one-round',
   ONE_DAY = 'one-day',
}

export enum MEMBERSHIP_AVAILABILITY {
   ALL = 'all',
   APP_ONLY = 'app-only',
   WEB_ONLY = 'web-only',
   CONTACT = 'contact',
}

export enum USER_MEMBERSHIP_STATUS {
   ACTIVE = 'active',
   INACTIVE = 'inactive',
   PAUSED = 'paused',
   CANCELLED = 'cancelled',
   EXPIRED = 'expired',
}

export enum USER_MEMBERSHIP_ORIGIN {
   REFERRAL_REWARD = 'referral-reward',
   PURCHASE = 'purchase',
   FREE_TRIAL = 'free-trial',
}
